/**
 * TanStack Router: /training/new
 *
 * This route file was auto-generated by the route generation script.
 * Component: TrainingNewPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import TrainingNewPage from '@/app/training/new/page'

/**
 * Route: /training/new
 * Layout: _auth (authenticated)
 * Component: TrainingNewPage
 */
export const Route = createFileRoute('/_auth/training/new')({
  component: TrainingNewPage,
})
